// extracted by mini-css-extract-plugin
export default {"NAD_wrapper":"NotesAndDocuments_NAD_wrapper__xIotV","NAD_inner_wrapper":"NotesAndDocuments_NAD_inner_wrapper__dXLxK","section_wrapper":"NotesAndDocuments_section_wrapper__PCWEM"};